export default "__VITE_ASSET__Crr6dVsj__"